kv.controller('contractViewCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal,cmdate, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
	vm.primaryKey = 'contract_id';
	vm.entity = 'contract';
	vm.entityType = 'contract';
	vm.groups = {};

	let url_segments = window.location.pathname.split('/');
	let page_entity_id = url_segments[2];
	let page_identifier = url_segments[3];

	vm.entityId = page_entity_id;
	vm.commentsConfig = {
		entity_type: vm.entity
	};

	vm.goBack = function () {
		$state.go("app.contracts");
	};


	vm.edit = function () {
		$state.go('app.' + vm.entity + '.edit', {id: vm.result[vm.primaryKey], result: vm.result});
	};

    /**
     * create an empowerment
     *
     * @param contract
     */
	vm.createEmpowerment = function (contract) {
		if(contract.contract_status_id === 4 || contract.contract_status_id === 5){
			let REST = resource.init('empowerment');
			REST.post({
				url: "empowerment/createFromContract",
				data: {
					contract_id: contract.contract_id,
				}
			}).then(function (response) {
				if (response && response.status && response.status === true) {
					window.open('/empowerment/' + response.data.empowerment_id, '_blank');
				} else {
					toastr.error(vm.trans('ERROR_WHILE_SAVING') + ' : ' + response.message);
				}
			});
		}else{
			toastr.error(vm.trans('EMPOWERMENT_FROM_CONTRACT_RESTRICTION'));
		}
	};

    /**
     * change contract status
     *
     * @param contract_status_id
     */
	vm.changeStatus = function (contract_status_id) {
        $http.post('/contract/' + vm.entityId + '/status/' + contract_status_id)
            .then(function (response) {
                if (response.status === 200 && response.data.status === true) {
                    toastr.success(vm.trans('DATA_HAS_BEEN_SAVED_WITH_SUCCESS'));
                    // wait a bit and reload page
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                } else {
                    toastr.error(vm.trans('ERROR_WHILE_SAVING'));
                }
            });
	};

	return vm;
});
